export const daysToSeconds = (days: number) => days * 24 * 60 * 60
